

export class BrandsTrimsDto{
    brandsTrimsId: number;
    masterBrandId:number;
    trimsId : number;
}